import {$ } from './Helpers/utils';


export default class ClientInfo{

    constructor(){
        this._data = {};
        this.init();
    }
    init(){
        this.get_info().then((r) => this.updateInfo(r));
    }
    updateInfo(r){
        console.log(r)
    }
    get_info(){
        return new Promise(((resolve, reject) => {

            $.ajax({
                type   : "GET",
                url    : "https://tickets.2207.co.il/api/v5/status.json",
                xhrFields: {
                    withCredentials: true
                },
                success: (r) => resolve(r),
                error  : function(r) {
                    console.log(r);
                    reject();
                }
            });

        }));
    }
}


